import React from 'react';

import type { Props } from 'Elements/Input/Select';

import { Select } from './VariantSelect.styled';

const VariantSelect: React.FC<Props> = (props, ...rest) => {
    return <Select {...props} {...rest} />;
};

export default VariantSelect;
